import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    workspaceId: '',
    name: '',
    sparkComputeType: '',
    owners: [],
    createCompute: getDefaultAsyncWrapperObj(),
    updateCompute: getDefaultAsyncWrapperObj(),
    synapseSubClusterList: [],
    cluster: '',
    vcName: '',
    maxConcurrency: '',
    servicePrincipalName: '',
    adlaAccountName: '',
    servicePrincipalNameList: getDefaultAsyncWrapperObj(),
    managedIdentityList: getDefaultAsyncWrapperObj(),
    managedIdentityId: '',
    touchTabs: {
        basic: false,
        subCluster: false,
    },
};
// Action Types
const loadServicePrincipalNameListPrefix = 'loadServicePrincipalNameList';
export const loadServicePrincipalNameListActionTypes = {
    LOAD: `${loadServicePrincipalNameListPrefix}/LOAD`,
    LOADING: `${loadServicePrincipalNameListPrefix}/LOADING`,
    LOADED: `${loadServicePrincipalNameListPrefix}/LOADED`,
};
const loadManagedIdentityListPrefix = 'loadManagedIdentityList';
export const loadManagedIdentityListActionTypes = {
    LOAD: `${loadManagedIdentityListPrefix}/LOAD`,
    LOADING: `${loadManagedIdentityListPrefix}/LOADING`,
    LOADED: `${loadManagedIdentityListPrefix}/LOADED`,
};
const createComputePrefix = 'createCompute';
export const createComputeActionTypes = {
    LOAD: `${createComputePrefix}/LOAD`,
    LOADING: `${createComputePrefix}/LOADING`,
    LOADED: `${createComputePrefix}/LOADED`,
};
const updateComputePrefix = 'updateCompute';
export const updateComputeActionTypes = {
    LOAD: `${updateComputePrefix}/LOAD`,
    LOADING: `${updateComputePrefix}/LOADING`,
    LOADED: `${updateComputePrefix}/LOADED`,
};
export const CLEAR_COMPUTE_UPDATE_ACTION = `${updateComputePrefix}/CLEAR_REQUEST`;
export const createComputeConstants = {
    setNameContext: `${createComputePrefix}/SetNameContext`,
    setSparkComputeTypeContext: `${createComputePrefix}/SetSparkComputeTypeContext`,
    setOwnersContext: `${createComputePrefix}/SetOwnersContext`,
    setSynapseContext: `${createComputePrefix}/SetSynapseContext`,
    setClusterContext: `${createComputePrefix}/SetClusterContext`,
    setVCNameContext: `${createComputePrefix}/SetVCNameContext`,
    setMaxConcurrencyContext: `${createComputePrefix}/SetMaxConcurrencyContext`,
    setServicePrincipalNameContext: `${createComputePrefix}/setServicePrincipalNameContext`,
    setManagedIdentityIdContext: `${createComputePrefix}/setManagedIdentityIdContext`,
    setAdlaAccountNameContext: `${createComputePrefix}/setAdlaAccountNameContext`,
    setTouchTabs: `${createComputePrefix}/SetTouchTabs`,
    setCreateCompute: `${createComputePrefix}/SetCreateCompute`,
    setUpdateCompute: `${createComputePrefix}/setUpdateCompute`,
};
export function SetNameContext(name) {
    return {
        type: createComputeConstants.setNameContext,
        payload: name,
    };
}
export function SetSparkComputeTypeContext(sparkComputeType) {
    return {
        type: createComputeConstants.setSparkComputeTypeContext,
        payload: sparkComputeType,
    };
}
export function SetOwnersContext(owners) {
    return {
        type: createComputeConstants.setOwnersContext,
        payload: owners,
    };
}
export function SetSynapseSubClusterListContext(synapseSubClusterList) {
    return {
        type: createComputeConstants.setSynapseContext,
        payload: synapseSubClusterList,
    };
}
export function SetClusterContext(cluster) {
    return {
        type: createComputeConstants.setClusterContext,
        payload: cluster,
    };
}
export function SetVCNameContext(vcName) {
    return {
        type: createComputeConstants.setVCNameContext,
        payload: vcName,
    };
}
export function SetMaxConcurrencyContext(maxConcurrency) {
    return {
        type: createComputeConstants.setMaxConcurrencyContext,
        payload: maxConcurrency,
    };
}
export function SetServicePrincipalNameContext(servicePrincipalName) {
    return {
        type: createComputeConstants.setServicePrincipalNameContext,
        payload: servicePrincipalName,
    };
}
export function SetManagedIdentityIdContext(managedIdentityId) {
    return {
        type: createComputeConstants.setManagedIdentityIdContext,
        payload: managedIdentityId,
    };
}
export function SetAdlaAccountNameContext(adlaAccountName) {
    return {
        type: createComputeConstants.setAdlaAccountNameContext,
        payload: adlaAccountName,
    };
}
export function SetTouchTabs(touchTabs) {
    return {
        type: createComputeConstants.setTouchTabs,
        payload: touchTabs,
    };
}
export function SetCreateCompute(createCompute) {
    return {
        type: createComputeConstants.setCreateCompute,
        payload: createCompute,
    };
}
export function SetUpdateCompute(updateCompute) {
    return {
        type: createComputeConstants.setUpdateCompute,
        payload: updateCompute,
    };
}
const setNameContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { name: actionResult.payload.name });
};
const setSparkComputeTypeContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { sparkComputeType: actionResult.payload.sparkComputeType });
};
const setOwnersContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { owners: actionResult.payload.owners });
};
const setSynapseSubClusterListContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { synapseSubClusterList: actionResult.payload.synapseSubClusterList });
};
const setClusterContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { cluster: actionResult.payload.cluster });
};
const setVCNameContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { vcName: actionResult.payload.vcName });
};
const setMaxConcurrencyContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { maxConcurrency: actionResult.payload.maxConcurrency });
};
const setServicePrincipalNameContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { servicePrincipalName: actionResult.payload.servicePrincipalName });
};
const setManagedIdentityIdContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { managedIdentityId: actionResult.payload.managedIdentityId });
};
const setAdlaAccountNameContext = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { adlaAccountName: actionResult.payload.adlaAccountName });
};
const setTouchTabs = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { touchTabs: actionResult.payload.touchTabs });
};
const setCreateCompute = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { createCompute: actionResult.payload.createCompute });
};
const setUpdateCompute = (state, actionResult) => {
    return Object.assign(Object.assign({}, state), { updateCompute: actionResult.payload.updateCompute });
};
// Action Creator
///////////////////////////////////////////
export const loadServicePrincipalNameList = (workspaceId) => {
    return {
        type: loadServicePrincipalNameListActionTypes.LOAD,
        payload: {
            workspaceId,
        },
    };
};
export const loadingServicePrincipalNameList = (workspaceId) => {
    return {
        type: loadServicePrincipalNameListActionTypes.LOADING,
        payload: {
            workspaceId,
        },
    };
};
export const loadedServicePrincipalNameList = (workspaceId, servicePrincipalNameList) => {
    return {
        type: loadServicePrincipalNameListActionTypes.LOADED,
        payload: {
            workspaceId,
            servicePrincipalNameList,
        },
    };
};
//loadManagedIdentityList
export const loadManagedIdentityList = (workspaceId) => {
    return {
        type: loadManagedIdentityListActionTypes.LOAD,
        payload: {
            workspaceId,
        },
    };
};
export const loadingManagedIdentityList = (workspaceId) => {
    return {
        type: loadManagedIdentityListActionTypes.LOADING,
        payload: {
            workspaceId,
        },
    };
};
export const loadedManagedIdentityList = (workspaceId, managedIdentityList) => {
    return {
        type: loadManagedIdentityListActionTypes.LOADED,
        payload: {
            workspaceId,
            managedIdentityList,
        },
    };
};
export const createCompute = (workspaceId, computeConfiguration) => {
    return {
        type: createComputeActionTypes.LOAD,
        payload: computeConfiguration,
    };
};
export const creatingCompute = () => {
    return {
        type: createComputeActionTypes.LOADING,
        payload: {},
    };
};
export const createdCompute = (createCompute) => {
    return {
        type: createComputeActionTypes.LOADED,
        payload: {
            createCompute,
        },
    };
};
export const updateCompute = (computeConfiguration) => {
    return {
        type: updateComputeActionTypes.LOAD,
        payload: computeConfiguration,
    };
};
export const updatingCompute = () => {
    return {
        type: updateComputeActionTypes.LOADING,
        payload: {},
    };
};
export const updatedCompute = (updateCompute) => {
    return {
        type: updateComputeActionTypes.LOADED,
        payload: {
            updateCompute,
        },
    };
};
export const clearComputeUpdateRequest = () => {
    return {
        type: CLEAR_COMPUTE_UPDATE_ACTION,
    };
};
// Reducer
export const computeCreateReducer = (state = defaultReducerState, action) => {
    var _a, _b, _c, _d, _e, _f;
    switch (action.type) {
        case createComputeConstants.setNameContext:
            return setNameContext(state, action);
        case createComputeConstants.setSparkComputeTypeContext:
            return setSparkComputeTypeContext(state, action);
        case createComputeConstants.setOwnersContext:
            return setOwnersContext(state, action);
        case createComputeConstants.setSynapseContext:
            return setSynapseSubClusterListContext(state, action);
        case createComputeConstants.setClusterContext:
            return setClusterContext(state, action);
        case createComputeConstants.setVCNameContext:
            return setVCNameContext(state, action);
        case createComputeConstants.setMaxConcurrencyContext:
            return setMaxConcurrencyContext(state, action);
        case createComputeConstants.setServicePrincipalNameContext:
            return setServicePrincipalNameContext(state, action);
        case createComputeConstants.setManagedIdentityIdContext:
            return setManagedIdentityIdContext(state, action);
        case createComputeConstants.setAdlaAccountNameContext:
            return setAdlaAccountNameContext(state, action);
        case createComputeConstants.setTouchTabs:
            return setTouchTabs(state, action);
        case createComputeConstants.setCreateCompute:
            return setCreateCompute(state, action);
        case createComputeConstants.setUpdateCompute:
            return setUpdateCompute(state, action);
        ////////////// LOADING ///////////////
        case loadServicePrincipalNameListActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { servicePrincipalNameList: Object.assign(Object.assign({}, state.servicePrincipalNameList), { status: AsyncRequestStatus.Pending }) });
        case loadManagedIdentityListActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { managedIdentityList: Object.assign(Object.assign({}, state.managedIdentityList), { status: AsyncRequestStatus.Pending }) });
        case createComputeActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { createCompute: Object.assign(Object.assign({}, state.createCompute), { status: AsyncRequestStatus.Pending }) });
        case updateComputeActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { updateCompute: Object.assign(Object.assign({}, state.updateCompute), { status: AsyncRequestStatus.Pending }) });
        ///////////// LOADED /////////////////////
        case loadServicePrincipalNameListActionTypes.LOADED:
            return Object.assign(Object.assign({}, state), { servicePrincipalNameList: Object.assign(Object.assign({}, state.servicePrincipalNameList), { data: (_a = action.payload.servicePrincipalNameList) === null || _a === void 0 ? void 0 : _a.data, status: !!((_b = action.payload.servicePrincipalNameList) === null || _b === void 0 ? void 0 : _b.error) ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed, error: (_c = action.payload.servicePrincipalNameList) === null || _c === void 0 ? void 0 : _c.error }) });
        case loadManagedIdentityListActionTypes.LOADED:
            return Object.assign(Object.assign({}, state), { managedIdentityList: Object.assign(Object.assign({}, state.managedIdentityList), { data: (_d = action.payload.managedIdentityList) === null || _d === void 0 ? void 0 : _d.data, status: !!((_e = action.payload.managedIdentityList) === null || _e === void 0 ? void 0 : _e.error) ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed, error: (_f = action.payload.managedIdentityList) === null || _f === void 0 ? void 0 : _f.error }) });
        case createComputeActionTypes.LOADED:
            return Object.assign(Object.assign({}, state), { createCompute: Object.assign(Object.assign({}, state.createCompute), { data: action.payload.createCompute.data, status: !!action.payload.createCompute.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed, error: action.payload.createCompute.error }) });
        case updateComputeActionTypes.LOADED:
            return Object.assign(Object.assign({}, state), { updateCompute: Object.assign(Object.assign({}, state.updateCompute), { data: action.payload.updateCompute.data, status: !!action.payload.updateCompute.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed, error: action.payload.updateCompute.error }) });
        case CLEAR_COMPUTE_UPDATE_ACTION:
            return Object.assign(Object.assign({}, state), { updateCompute: getDefaultAsyncWrapperObj() });
        default:
            return state;
    }
};
export default computeCreateReducer;

//# sourceMappingURL=ComputeCreateContainer.ducks.js.map
